<template>
  <div>
    <div class="bg-secondary rounded max-w-400">
      <div class="flex h-339 justify-center items-center">
        <div class="border border-default rounded py-50
         responsive-size">
        <div class="w-full h-full">
          <div class="card-subtitle">{{ $t("login_signup") }}</div>
          <div class="card-text font-medium">{{ $t("with_phone_number") }}</div>
          <div class="mt-36">
            <form action="submit" @submit.prevent="submitPhoneNumber">
              <phone-number-input
                @countryCode="getCountryCode"
                @isPhoneValid="phoneValidation"
                :isLogin="true"
              />
              <div class="mt-20 h-48">
                <base-button
                  :disabled="isButtonDisabled"
                  width="318"
                  height="48"
                  buttonType="primary"
                  radius="sm"
                  type="submit"
                >
                  <template #icon v-if="loadingButton">
                    <div class="w-18 h-18">
                      <base-loading size="full" borderWidth="2" />
                    </div>
                  </template>
                  <template #text v-else> {{ $t("next") }} </template>
                </base-button>
              </div>
            </form>
          </div>
          <div class="text-12 mt-2 text-subtitle">
            <a class="text-subtitle pointer"
            href="https://novaday.ir/nova-access/terms" target="_blank">
              {{ $t("accept_term_checkbox") }}
            </a>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseButton from '@/components/base/BaseButton.vue';
import PhoneNumberInput from '@/components/PhoneNumberInput.vue';
import BaseLoading from '@/components/base/BaseLoading.vue';

export default {
  components: {
    BaseButton,
    PhoneNumberInput,
    BaseLoading,
  },
  data() {
    return {
      isButtonDisabled: true,
    };
  },
  mounted() {
    this.$store.commit('authentication/LOGIN_FAILURE');
  },
  computed: {
    loadingButton() {
      return this.$store.state.loading.loadingButton;
    },
  },
  methods: {
    getCountryCode(code) {
      this.$store.state.authentication.countryCode = code;
    },
    submitPhoneNumber() {
      this.isButtonDisabled = true;
      this.$store.commit('loading/LOADING_HANDLER', true);
      this.$store
        .dispatch('authentication/login')
        .then(() => {
          this.isButtonDisabled = false;
          this.$store.commit('loading/LOADING_HANDLER', false);
        })
        .catch(() => {
          this.isButtonDisabled = false;
          this.$store.commit('loading/LOADING_HANDLER', false);
        });
    },
    phoneValidation(val) {
      this.isButtonDisabled = val;
    },
  },
};
</script>
<style scoped>
@media (min-width: 1024px) {
  .responsive-size {
    padding-left: 30px;
    padding-right: 30px;
  }
}
@media (min-width: 769px) and (max-width: 1024px) {
  .responsive-size {
    padding-left: 10px;
    padding-right: 10px;
  }
}

@media (min-width: 375px) and (max-width: 768px) {
  .responsive-size {
    padding-left: 30px;
    padding-right: 30px;
  }
}
@media (max-width: 375px) {
  .responsive-size {
    padding-left: 10px;
    padding-right: 10px;
  }
}
</style>
